// Module
var code = "<script>let $ctrl</script> <div class=\"grid-stack-item-content\"> <div class=\"grid-stack-item-content-inner\"> <molecule-form-edit> <molecule-panel-prepaid as-widget=\"true\"></molecule-panel-prepaid> </molecule-form-edit> </div> </div> ";
// Exports
module.exports = code;